/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export const RESET_ALL_COLLECTION_SCREEN_FILTERS = 'RESET_ALL_COLLECTION_SCREEN_FILTERS';

export const RESET_COLLECTION_SCREEN_FILTER = 'RESET_COLLECTION_SCREEN_FILTER';

export const SET_COLLECTION_SCREEN_FILTER_DETAILS = 'SET_COLLECTION_SCREEN_FILTER_DETAILS';

export const SET_COLLECTION_SCREEN_LAST_FOCUSED_ITEM_POSITION =
    'SET_COLLECTION_SCREEN_LAST_FOCUSED_ITEM_POSITION';

export const SET_FOCUS_ON_COLLECTION_SCREEN_DELETE_BUTTON =
    'SET_FOCUS_ON_COLLECTION_SCREEN_DELETE_BUTTON';

export const SET_FOCUS_ON_COLLECTION_SCREEN_GO_TO_EPISODE_BUTTON =
    'SET_FOCUS_ON_COLLECTION_SCREEN_GO_TO_EPISODE_BUTTON';

export const SET_COLLECTION_FILTER_SORT_ORDER = 'SET_COLLECTION_FILTER_SORT_ORDER';

export const SET_COLLECTION_FILTER_ITEMS_LOADING = 'SET_COLLECTION_FILTER_ITEMS_LOADING';

export const SET_COLLECTION_IS_LAST_PAGE = 'SET_COLLECTION_IS_LAST_PAGE';

export const SET_COLLECTION_PAGE_LOADING = 'SET_COLLECTION_PAGE_LOADING';

export const SET_COLLECTION_SCREEN_CARET = 'SET_COLLECTION_SCREEN_CARET';
